import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {compose} from "recompose";
import {withRouter} from "react-router-dom";
import {Button, withStyles} from "@material-ui/core";
import MyLocationIcon from '@material-ui/icons/MyLocation';
import t from "../../../languages/pl";
import CarAvatar from "../../MapComponents/CarList/CarAvatar";
import DescriptionDetail from './CarDetails/DescriptionDetail';
import Groups from "./CarDetails/Groups";
import CarSettings from "./CarDetails/CarSettings";
import CarRenting from './CarDetails/CarRenting';
import CarAlarms from './CarDetails/CarAlarms';
import CarDevice from './CarDetails/CarDevice';
import {themeTypeToBool} from '../../../utils/helpers';
import {connect} from "react-redux";
import {electricCarFuelTypeId} from "../../../config/constants";

const useStyles = theme => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        padding: theme.spacing(1),
        background: themeTypeToBool(theme.palette.type) ? "inherit" : "#656484",
        width: "100%",
        overflowX: 'hidden'
    },
    innerContainer: {
        display: "flex",
        [theme.breakpoints.down('md')]: {
            flexDirection: "column",
            maxWidth: 400
        },
    },
    avatar: {
        margin: theme.spacing(1)
    },
    detailsContainer: {
        display: "flex",
        minWidth: 350
    },
    carDetails: {
        display: "flex",
        flexDirection: "column",
        margin: theme.spacing(1)
    },
    carSettings: {
        marginLeft: theme.spacing(2)
    },
    showMapBtn: {
        margin: theme.spacing(1),
        textAlign: "center"
    }
});

const CarDetails = props => {
    const {
        classes, car, id, carType, registrationNo, vin, phoneNo, password, description, fuelLevel, fuelType, fuelTypeId,
        meterReading, serialNo, gpsState, lastComm, email, groups, onGroupDelete, isGpsEnabled, batteryCondition
    } = props;

    const [fuelLevelTypeLabel, setFuelLevelTypeLabel] = useState(t.fuelLevel);
    const [fuelLevelLabel, setFuelLevelLabel] = useState('');

    const handleMapRedirect = () => {
        props.history.push({
            pathname: "/map",
            search: `?id=${registrationNo}`
        });
    };

    useEffect(() => {
        const typeLabel = fuelTypeId === electricCarFuelTypeId ? t.batteryLevel : t.fuelLevel;
        const levelLabel = fuelTypeId === electricCarFuelTypeId ? `${fuelLevel}% ` : `${fuelLevel} l`;
        setFuelLevelTypeLabel(typeLabel);
        setFuelLevelLabel(levelLabel);
    }, [fuelTypeId]);

    return (
        <div className={classes.container}>
            <div>
                <div className={classes.detailsContainer}>
                    <div className={classes.avatar}>
                        <CarAvatar
                            type={carType}
                        />
                    </div>
                    <div className={classes.carDetails}>
                        <DescriptionDetail title={t.vinNo} value={vin}/>
                        <DescriptionDetail title={t.phone} value={phoneNo}/>
                        <DescriptionDetail title={t.passwordLabel} value={password}/>
                        <DescriptionDetail title={t.description} value={description}/>
                        <DescriptionDetail title={fuelLevelTypeLabel} value={fuelLevelLabel}/>
                        <DescriptionDetail title={t.fuelType} value={fuelType}/>
                        <DescriptionDetail title={t.batteryCondition} value={batteryCondition}/>
                        <DescriptionDetail title={t.currentMileageState} value={meterReading}/>
                        <DescriptionDetail title={t.serialNo} value={serialNo}/>
                        <DescriptionDetail title={t.currently}
                                           value={gpsState === "Rozłączony+" ? "Rozłączony > 24h" : gpsState}/>
                        <DescriptionDetail title={t.lastComm} value={lastComm}/>
                        <DescriptionDetail title={t.email}
                                           value={typeof email === 'string' ? email : email.join(', ')}/>
                    </div>
                </div>
                <div className={classes.showMapBtn}>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!isGpsEnabled}
                        startIcon={<MyLocationIcon/>}
                        onClick={handleMapRedirect}
                    >
                        {t.showOnMap}
                    </Button>
                </div>
            </div>
            <div className={classes.carSettings}>
                <div className={classes.innerContainer}>
                    <CarSettings
                        carId={id}
                        registrationNo={registrationNo}
                        carType={carType}
                    />
                    <div>
                        <div className={classes.innerContainer}>
                            <CarRenting
                                carId={id}
                                registrationNo={registrationNo}
                                carType={carType}
                            />
                            <CarAlarms
                                carId={id}
                                registrationNo={registrationNo}
                            />
                        </div>
                        <CarDevice
                            carId={id}
                            registrationNo={registrationNo}
                            gpsState={gpsState}
                            car={car}
                        />
                    </div>
                </div>
                <Groups title={t.groups} groups={groups} onDelete={(groupId) => onGroupDelete(groupId, id)}/>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        isGpsEnabled: state.authReducer.isGpsEnabled,
    };
};

export default compose(
    connect(
        mapStateToProps,
        null
    ),
    withStyles(useStyles),
    withRouter
)(CarDetails);

CarDetails.propTypes = {
    classes: PropTypes.object,
    car: PropTypes.object,
    id: PropTypes.number,
    carType: PropTypes.string,
    registrationNo: PropTypes.string,
    vin: PropTypes.string,
    phoneNo: PropTypes.string,
    password: PropTypes.string,
    description: PropTypes.string,
    fuelLevel: PropTypes.number,
    fuelType: PropTypes.string,
    fuelTypeId: PropTypes.number,
    meterReading: PropTypes.number,
    fuelUsage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    serialNo: PropTypes.string,
    gpsState: PropTypes.string,
    lastComm: PropTypes.string,
    batteryCondition: PropTypes.number,
    email: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    groups: PropTypes.array,
    onGroupDelete: PropTypes.func,
    //router
    history: PropTypes.object,
    isGpsEnabled: PropTypes.bool
};
